if (!customElements.get("milestone-candle-flow")) {
  customElements.define(
    "milestone-candle-flow",
    class PersonalizeCandleFlow extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = document.querySelector(
          "#personalize-add-to-cart-btn"
        );
        this.personalizeBlock = document.querySelector("#personalize-block");
        this.personalizeOpenButton = document.querySelector(
          "#personalize-open-btn"
        );
        this.personalizeCloseButton = document.querySelector(
          "#personalize-close-btn"
        );
        this.personalizeForm = document.querySelector("#personalize-form");
        this.resultBackButton = document.querySelector(
          "#personalize-result-back-btn"
        );
        this.heroContent = document.querySelector("#product-hero-content");
        this.personalizeResultBlock = document.querySelector(
          "#personalize-result"
        );
        this.personaliseAddToCartBtn = document.querySelector(
          "#personalize-add-to-cart-btn"
        );
        this.loader = document.querySelector("#personalize-loader");

        if (document.querySelector(".cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      connectedCallback() {
        if (this.personalizeBlock) {
          this.personalizeOpenButton.addEventListener("click", () =>
            this.openPersonalizeModal()
          );
          this.personalizeCloseButton.addEventListener("click", () =>
            this.closePersonalizeModal()
          );
          this.personalizeForm.addEventListener("submit", (e) =>
            this.personalizeFormSubmit(e)
          );
          this.resultBackButton.addEventListener("click", () =>
            this.showPersonalizeBlock()
          );
          this.personaliseAddToCartBtn.addEventListener("click", () =>
            this.form.requestSubmit()
          );
          this.watchStandardInputs();
          this.watchCustomSelects();
          this.changeFragranceOptionByCustomSelect();
          this.watchMilestoneChange();
          this.watchRadioInputs();
          this.watchGreetingChange();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const formData = new FormData(this.form);
        const variantId = formData.get("id");
        const payload = {};

        const bundleProp = formData.get("properties[_bundle]");

        if (bundleProp) {
          payload.properties = {
            _bundle: bundleProp,
          };
        }

        if (this.personalizeProperties && Object.keys(this.personalizeProperties).length > 0) {
          const props = { ...this.personalizeProperties };

          props._background = this.slugify(props._background);
          props._milestone = this.slugify(props._milestone);

          payload.properties = props;
        }

        const quantity = formData.get("quantity") || 1;

        window.BIRTHDATE_CART.addVariant({ id: variantId }, quantity, payload, {
          ensureUnique: this.dataset.ensureUnique === "true",
        }).finally(() => {
          setTimeout(() => {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
          }, 10);
        });
      }

      openPersonalizeModal() {
        this.personalizeBlock.classList.remove("hidden");
        this.heroContent.classList.add("hidden");
      }

      closePersonalizeModal() {
        this.personalizeBlock.classList.add("hidden");
        this.heroContent.classList.remove("hidden");
      }

      personalizeFormSubmit(e) {
        e.preventDefault();

        if (!this.validatePersonalizeForm()) return;

        const formData = new FormData(e.target);
        const json = Object.fromEntries(
          Array.from(formData.entries()).filter(
            ([key, value]) => value.trim() !== ""
          )
        );
        const transformed = this.transformData(json);
        this.personalizeProperties = transformed;

        this.onShowPreview(e);
        this.renderResultMarkup(this.personalizeProperties);
      }

      transformData(data) {
        const { _day, _month, _year, ...rest } = data;

        return {
          ...rest,
          _date: `${_year}-${_month}-${_day}`,
        };
      }

      validateCustomSelects() {
        const requiredHiddenInputs = this.personalizeForm.querySelectorAll(
          'input[type="hidden"][required]'
        );
        let isValid = true;

        requiredHiddenInputs.forEach((input) => {
          const wrapper = input.closest(".custom-select");

          if (!input.value.length) {
            isValid = false;
            wrapper.classList.add("custom-select--error");
          } else {
            wrapper.classList.remove("custom-select--error");
          }
        });

        return isValid;
      }

      watchCustomSelects() {
        const customSelects =
          this.personalizeForm.querySelectorAll(".custom-select");

        customSelects.forEach((selectWrapper) => {
          const options = selectWrapper.querySelectorAll(".select-option");

          if (options.length === 0) return;

          options.forEach((option) => {
            option.addEventListener("click", () => {
              selectWrapper.classList.remove("custom-select--error");
            });
          });
        });
      }

      validateStandardInputs() {
        const fields = this.personalizeForm.querySelectorAll(
          'input[required]:not([type="hidden"]), textarea[required], select[required]'
        );
        let isValid = true;

        fields.forEach((field) => {
          const value = field.value.trim();
          if (!value.length) {
            isValid = false;
            field.classList.add("input--error", "border-[#ff564f]");
          } else {
            field.classList.remove("input--error", "border-[#ff564f]");
          }
        });

        return isValid;
      }

      watchStandardInputs() {
        const fields = this.personalizeForm.querySelectorAll(
          'input[required]:not([type="hidden"]), textarea[required], select[required]'
        );

        fields.forEach((field) => {
          field.addEventListener("input", () => {
            field.classList.remove("input--error", "border-[#ff564f]");
          });
        });
      }

      validatePersonalizeForm() {
        const isStandardValid = this.validateStandardInputs();
        const isCustomSelectsValid = this.validateCustomSelects();
        const isRadiosValid = this.validateRadioGroups();

        return isStandardValid && isCustomSelectsValid && isRadiosValid;
      }

      async onShowPreview(e) {
        e.preventDefault();
        const button = document.querySelector("#show-result-btn");
        const errorBox = document.querySelector("#personalize-error-message");

        button.disabled = true;
        button.classList.add("loading");
        const originalText = button.innerHTML;
        button.innerHTML = "Loading...";
        document.body.classList.add("lock");
        this.loader.classList.remove("!hidden");

        const formData = new FormData(this.personalizeForm);
        const json = Object.fromEntries(formData.entries());
        const transformed = this.transformData(json);
        const cleanedParams = this.cleanParams(transformed);
        const requiredKeys = [
          "person1Name",
          "person2Name",
          "date",
          "background",
          "milestone",
          "greeting",
          "fragrance",
        ];
        const params = {};

        const uiReset = () => {
          this.showPersonalizeResult();
          button.disabled = false;
          button.classList.remove("loading");
          button.innerHTML = originalText;
          this.loader.classList.add("!hidden");
          document.body.classList.remove("lock");
        };

        for (const key of requiredKeys) {
          const value = cleanedParams[key];
          if (value) {
            params[key] = value;
          } else {
            console.warn(`Missing required param: ${key}`);
          }
        }

        const paramsString = JSON.stringify(params);

        if (this.lastPreviewParams === paramsString) {
          uiReset();
          return;
        }

        this.lastPreviewParams = paramsString;
        const paramsForUrl = {
          ...params,
          background: this.slugify(params.background),
          milestone: this.slugify(params.milestone),
        };

        const queryString = new URLSearchParams(paramsForUrl).toString();
        const url = `https://api.fiocompanies.com/v1/products/milestone-candle/preview?${queryString}`;

        try {
          const previewImages = await this.getPreviewImages(url);

          window.addDynamicSlides(previewImages);
          window.addSlidesToProductModal(previewImages);
        } catch (error) {
          if (errorBox) {
            errorBox.classList.remove("hidden");
            setTimeout(() => {
              errorBox.classList.add("hidden");
            }, 8000);
          }
          console.error("Failed to load preview image:", error.message);
        } finally {
          uiReset();
        }
      }

      slugify = (value) => {
        return value
          .toString()
          .toLowerCase()
          .normalize("NFD")         
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/['’]/g, "")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/(^-|-$)+/g, "");
      };

      async getPreviewImages(url) {
        const response = await fetch(url);

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || "Failed to fetch preview image");
        }

        const data = await response.json();

        return data.images;
      }

      cleanParams(obj) {
        const cleaned = {};
        for (const key in obj) {
          if (key.startsWith("_")) {
            cleaned[key.substring(1)] = obj[key];
          } else {
            cleaned[key] = obj[key];
          }
        }
        return cleaned;
      }

      renderResultMarkup(personalizeProperties) {
        const {
          _background,
          _fragrance,
          _milestone,
          _greeting,
          _person1Name,
          _date,
          _person2Name,
        } = personalizeProperties;

        const background = this.personalizeResultBlock.querySelector(
          "#result-background-print"
        );
        const fragrance =
          this.personalizeResultBlock.querySelector("#result-fragrance");
        const milestone =
          this.personalizeResultBlock.querySelector("#result-milestone");
        const greeting = this.personalizeResultBlock.querySelector(
          "#result-milestone-greeting"
        );
        const personOne =
          this.personalizeResultBlock.querySelector("#result-person");
        const date = this.personalizeResultBlock.querySelector("#result-date");
        const personTwoName = this.personalizeResultBlock.querySelector(
          "#result-second-person"
        );

        if (background) background.textContent = _background;
        if (fragrance) fragrance.textContent = _fragrance;
        if (milestone) milestone.textContent = _milestone;
        if (greeting) greeting.textContent = _greeting;
        if (personOne) personOne.textContent = _person1Name;
        if (date) date.textContent = _date;
        if (personTwoName && _person2Name) {
          personTwoName.parentElement.classList.remove("hidden");
          personTwoName.textContent = _person2Name;
        } else {
          personTwoName.parentElement.classList.add("hidden");
        }
      }

      showPersonalizeResult() {
        if (!this.personalizeResultBlock) return;

        this.personalizeResultBlock.classList.remove("!hidden");
        this.personalizeBlock.classList.add("!hidden");
        this.heroContent.classList.add("hidden");
      }

      showPersonalizeBlock() {
        if (!this.personalizeResultBlock) return;

        this.personalizeResultBlock.classList.add("!hidden");
        this.personalizeBlock.classList.remove("!hidden");
      }

      changeFragranceOptionByCustomSelect() {
        const input = document.querySelector('input[name="_fragrance"]');
        const selects = document.querySelectorAll("select.form-select");

        if (!input) return;

        const syncSelects = () => {
          const inputValue = input.value.trim();

          selects.forEach((select) => {
            let matchedOption = null;

            Array.from(select.options).forEach((option) => {
              if (option.text.trim() === inputValue) {
                matchedOption = option;
              }
              option.selected = false;
            });

            if (matchedOption) {
              matchedOption.selected = true;
              select.value = matchedOption.value;
              select.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        };

        input.addEventListener("input", syncSelects);

        const observer = new MutationObserver(syncSelects);
        observer.observe(input, {
          attributes: true,
          attributeFilter: ["value"],
        });
        syncSelects();
      }

      watchMilestoneChange() {
        const milestoneInput = this.personalizeForm.querySelector(
          'input[name="_milestone"]'
        );
        const options = milestoneInput
          .closest(".custom-select")
          .querySelectorAll(".select-option");
        const greetingBlock =
          this.personalizeForm.querySelector("#greeting-block");
        const greetingInput = greetingBlock.querySelector(
          'input[name="_greeting"]'
        );
        const greetingPlaceholder = greetingBlock.querySelector(
          "[data-placeholder-text]"
        );
        const otherGreetingBlock = greetingBlock.querySelector(
          "#greeting-other-version-block"
        );
        const greetingOptions =
          greetingBlock?.querySelectorAll(".select-option") || [];

        if (!milestoneInput || options.length === 0) return;

        const filterGreetingOptions = (value) => {
          if (!greetingBlock || greetingOptions.length === 0) return;

          const normalized = value.trim().toLowerCase();
          let allowed = [];

          switch (normalized) {
            case "happy anniversary":
              allowed = [
                "Forever and Counting",
                "Love That Lasts",
                "A Love Worth Celebrating",
                "Write Your Own",
              ];
              break;
            case "wedding day":
              allowed = [
                "Joined in Love",
                "The Beginning of Forever",
                "Happily Ever After Starts Here",
                "Write Your Own",
              ];
              break;
            case "congratulations":
              allowed = [
                "So Proud of You",
                "Here's to You",
                "To Your Success",
                "Write Your Own",
              ];
              break;
            case "it's a boy":
              allowed = [
                "Oh Boy!",
                "Sweet Little Star",
                "The Adventure Begins",
                "Write Your Own",
              ];
              break;
            case "it's a girl":
              allowed = [
                "Hello, Little One",
                "Darling Girl",
                "Her Beautiful Beginning",
                "Write Your Own",
              ];
              break;
            case "welcome home":
              allowed = [
                "Home Sweet Home",
                "The Start of Something Good",
                "A New Chapter Begins",
                "Write Your Own",
              ];
              break;
            case "happy birthday":
              allowed = [
                "Make a Wish",
                "Cheers to You",
                "Another Year Brighter",
                "Write Your Own",
              ];
              break;
            default:
              greetingBlock.classList.add("hidden");
              return;
          }

          greetingOptions.forEach((li) => {
            const text = li.dataset.value || li.textContent.trim();

            if (allowed.includes(text)) {
              li.classList.remove("hidden");
            } else {
              li.classList.add("hidden");
            }
          });
        };

        options.forEach((option) => {
          option.addEventListener("click", () => {
            const selectedValue = option.dataset.value.trim().toLowerCase();

            milestoneInput.value = selectedValue;
            filterGreetingOptions(milestoneInput.value);
            this.toggleSecondPersonBlock(milestoneInput.value);
            greetingPlaceholder.textContent = greetingPlaceholder.getAttribute(
              "data-placeholder-text"
            );
            greetingPlaceholder.classList.add("selected-value--placeholder");
            greetingInput.value = "";
            greetingBlock.classList.remove("hidden");
            otherGreetingBlock.classList.add('hidden');
          });
        });
      }

      toggleSecondPersonBlock = (value) => {
        const secondPersonBlock =
          this.personalizeForm.querySelector("#second-person");
        if (!secondPersonBlock) return;

        const input = secondPersonBlock.querySelector(
          'input[name="_person2Name"]'
        );
        const normalized = value.trim().toLowerCase();

        if (
          ["wedding day", "happy anniversary", "welcome home"].includes(
            normalized
          )
        ) {
          secondPersonBlock.classList.remove("hidden");
          input.setAttribute("required", "");
        } else {
          input.removeAttribute("required");
          secondPersonBlock.classList.add("hidden");
          input.value = "";
        }
      };

      watchGreetingChange() {
        const greetingBlock =
          this.personalizeForm.querySelector("#greeting-block");
        if (!greetingBlock) return;

        const options = greetingBlock
          .querySelector(".custom-select")
          .querySelectorAll(".select-option");
        const otherGreetingBlock = greetingBlock.querySelector(
          "#greeting-other-version-block"
        );
        const charCount = greetingBlock.querySelector("#char-count");
        const otherTextarea = greetingBlock.querySelector(
          "#greetingOtherVersion"
        );
        const greetingInput = greetingBlock.querySelector(
          'input[name="_greeting"]'
        );

        options.forEach((option) => {
          option.addEventListener("click", () => {
            const selectedValue = option.dataset.value.trim().toLowerCase();

            if (
              selectedValue === "other" ||
              selectedValue === "write your own"
            ) {
              otherGreetingBlock.classList.remove("hidden");
              otherTextarea.setAttribute("required", "");

              greetingInput.value = otherTextarea.value.trim()
                ? otherTextarea.value.trim()
                : "Other";
            } else {
              otherGreetingBlock.classList.add("hidden");
              otherTextarea.removeAttribute("required");
              otherTextarea.value = "";
            }
          });
        });

        if (otherTextarea && charCount) {
          const updateCharCount = () => {
            const count = otherTextarea.value.length;
            charCount.textContent = `Characters Used: ${count} / ${otherTextarea.getAttribute(
              "maxlength"
            )}`;
          };

          const updateMilestoneInput = () => {
            greetingInput.value = otherTextarea.value.trim();
          };

          updateCharCount();
          otherTextarea.addEventListener("input", () => {
            updateCharCount();
            updateMilestoneInput();
          });
        }
      }

      validateRadioGroups() {
        let isValid = true;

        const requiredRadios = this.personalizeForm.querySelectorAll(
          'input[type="radio"][required]'
        );
        const names = [
          ...new Set(Array.from(requiredRadios).map((r) => r.name)),
        ];

        names.forEach((name) => {
          const group = this.personalizeForm.querySelectorAll(
            `input[name="${name}"]`
          );
          const checked = Array.from(group).some((radio) => radio.checked);

          if (!checked) {
            isValid = false;
            group.forEach((radio) => {
              const label = this.personalizeForm.querySelector(
                `label[for="${radio.id}"]`
              );
              label.style.boxShadow = "0 0 0 3px #ff564f";
            });
          } else {
            group.forEach((radio) => {
              const label = this.personalizeForm.querySelector(
                `label[for="${radio.id}"]`
              );
              label.style.boxShadow = "";
            });
          }
        });

        return isValid;
      }

      watchRadioInputs() {
        const radios = this.personalizeForm.querySelectorAll(
          'input[type="radio"][required]'
        );
        const displayText = document.querySelector(
          "#current-background-swatch-text"
        );

        radios.forEach((radio) => {
          radio.addEventListener("change", () => {
            const group = this.personalizeForm.querySelectorAll(
              `input[name="${radio.name}"]`
            );
            group.forEach((r) => {
              const label = this.personalizeForm.querySelector(
                `label[for="${r.id}"]`
              );
              if (label) label.style.boxShadow = "";
            });

            const selectedLabel = this.personalizeForm.querySelector(
              `label[for="${radio.id}"]`
            );

            if (selectedLabel)
              selectedLabel.style.boxShadow = "0 0 0 3px #fff, 0 0 0 6px #000";

            if (displayText) {
              displayText.textContent = radio.value;
            }
          });
        });
      }
    }
  );
}
